// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2l2mO","name":"Header_name__jtTRW","birthday":"Header_birthday__3THgn","skeleton":"Header_skeleton__3PB0_"};